

import React from 'react';
import './index.scss';

function ComTag({
    title
}) {
    return (
        <div className='com-tag'>
            <div>- {title} -</div>
        </div>
    )
}

export default React.memo(ComTag);